import { render, staticRenderFns } from "./CriarPedidoDeCompraView.vue?vue&type=template&id=1ec66d4b&scoped=true"
import script from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarPedidoDeCompraView.vue?vue&type=style&index=0&id=1ec66d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec66d4b",
  null
  
)

export default component.exports